import { createStore } from 'redux'
import { useSelector, TypedUseSelectorHook } from 'react-redux'

type state = {
  sidebarShow: boolean
  sidebarUnfoldable: boolean
  asideShow: boolean
  emailShow: boolean
  theme: string
  menuShow: boolean
  respondentId: string
  selectedSurveyId: string
  email?: any
}

const initialState: state = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  asideShow: false,
  emailShow: false,
  menuShow: false,
  respondentId: '',
  selectedSurveyId: '',
  theme: 'default',
  email: {},
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type args = { type?: string; [key: string]: any }

const changeState = (state = initialState, { type, ...rest }: args) => {
  console.log(state, 'state')

  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store

// https://react-redux.js.org/using-react-redux/static-typing#typing-the-useselector-hook
export const useTypedSelector: TypedUseSelectorHook<state> = useSelector
